var map = {
	"./title-carousel.de-CH.json": 1246,
	"./title-carousel.de-DE.json": 1247,
	"./title-carousel.en-CA.json": 1248,
	"./title-carousel.en-GB.json": 1249,
	"./title-carousel.en-IN.json": 1250,
	"./title-carousel.en-ME.json": 1251,
	"./title-carousel.en-US.json": 1252,
	"./title-carousel.es-EM.json": 1253,
	"./title-carousel.es-ES.json": 1254,
	"./title-carousel.fr-BE.json": 1255,
	"./title-carousel.fr-CA.json": 1256,
	"./title-carousel.fr-CH.json": 1257,
	"./title-carousel.nl-BE.json": 1258,
	"./title-carousel.nl-NL.json": 1259,
	"./title-carousel.pl-PL.json": 1260,
	"./title-carousel.pt-BR.json": 1261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1245;